import React, { Component } from 'react';
import kominfoTeam4 from '../../assets/kominfo-team-4.png';

export default class Authority extends Component {
  render() {
    return (
      <section id="kewenangan-psre-induk">
        <p style={{fontSize: '18px', color: '#0085C7', fontWeight: '600', marginBottom: '25px'}}>6 Kewenangan PSrE Induk</p>
        <div class="row">
          <div class="col-lg-5 col-md-6 col-sm-12 col-12">
            <div class="position-relative w-100">
              <img src={kominfoTeam4} alt="kominfo-team-4" style={{width: '100%', height: 'auto', marginBottom: '15px'}}/>
            </div>
            <div class="caption-foto">
              <p style={{fontSize: '15px', fontWeight: '600', marginBottom: '30px'}}>"Kepastian Keamanan Teknologi Jadi Kunci Keberhasilan Untuk Meningkatkan Kepercayaan Masyarakat di Era Digital."</p>
              <p style={{fontSize: '13px', fontWeight: '600'}}>Mariam F. Barata</p>
              <p style={{fontSize: '13px'}}>Direktur Tata Kelola Aplikasi Informatika</p>
            </div>
          </div>
          <div class="col-lg-7 col-md-6 col-sm-12 col-12">
            <div class="d-flex mb-3">
              <div class="rect-blue">1</div>
              <div>
                <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Pemeriksaan</p>
                <p style={{fontSize: '13px'}}>calon pemilik dan/atau Pemegang <br/> Sertifikat Elektronik</p>
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="rect-blue">2</div>
              <div>
                <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Penerbitan</p>
                <p style={{fontSize: '13px'}}>Sertifikat Elektronik</p>
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="rect-blue">3</div>
              <div>
                <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Perpanjangan</p>
                <p style={{fontSize: '13px'}}>Masa Berlaku Sertifikat Elektronik</p>
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="rect-blue">4</div>
              <div>
                <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Pemblokiran</p>
                <p style={{fontSize: '13px'}}>dan Pencabutan Sertifikat Elektronik</p>
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="rect-blue">5</div>
              <div>
                <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Validasi</p>
                <p style={{fontSize: '13px'}}>Sertifikat Elektronik</p>
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="rect-blue">6</div>
              <div>
                <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>Pembuatan Daftar</p>
                <p style={{fontSize: '13px'}}>Sertifikat Elektronik yang Aktif dan Dibekukan</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}
